import React from 'react';
import { useIntl } from 'react-intl';
import { EmptyComponent, Evidence } from '@eas/common-web';
import { useDatedEvidence } from '@composite/evidence/dated-evidence';
import { NaSpisLogRecord } from '@models';
import { EvidenceApiUrl } from '@enums';
import { useColumns } from './naspis-log-record-columns';
import { Fields } from './naspis-log-record-fields';

export function NaspisLogRecords() {
  const intl = useIntl();

  const columns = useColumns();

  const evidence = useDatedEvidence<NaSpisLogRecord>({
    identifier: 'NASPIS_LOG_RECORD',
    apiProps: {
      url: EvidenceApiUrl.NASPIS_LOG_RECORDS,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ES__NASPIS_LOG_RECORDS__TABLE__TITLE',
        defaultMessage: 'Logování komunikace s NaSpisem',
      }),
      showReportButton: false,
      defaultSorts: [
        { field: 'created', datakey: 'created', type: 'FIELD', order: 'DESC' },
      ],
    },
    detailProps: {
      FieldsComponent: Fields,
      GeneralFieldsComponent: EmptyComponent,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__NASPIS_LOG_RECORDS__DETAIL__TITLE',
          defaultMessage: 'Log',
        }),
        showBtn: function showBtn(btn) {
          return ['SHARE', 'REFRESH'].includes(btn);
        },
      },
    },
  });

  return <Evidence {...evidence} />;
}
